export default __webpack_public_path__ + "static/media/download02.cf8bc843.png";